import React, { memo, useCallback } from "react";
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';
import {isSet} from '../../../../Utils/CommonFunctions';

const Percentage = (props)=>{
  const  {
    type,
    item,
    className,
    fieldObj,
    validationForms
  } = props;

//   const handleCheck = useCallback((e)=> {
//     let input_value = e.target.value;
//     var validNumber = new RegExp(/^\d*\.?\d*$/);
//     if (input_value <= 100 && validNumber.test(input_value)) {
//       e.target.value  = isSet(input_value,'');
//       props.onChangeInputAction(fieldObj,e);
//     } else {
//       e.target.value  = isSet(props.item.selectedValue,'');
//       props.onChangeInputAction(fieldObj,e);
//     }
//  });
const handleCheck = useCallback((e) => {
  let input_value = e.target.value;
  const maxLength = props.item.max;
  const maxDecimalLength = isSet(props.item.decimal,props.item.decimal_places);
  let pattern;
  if(maxDecimalLength === 0){
    pattern = new RegExp(/^\d*$/);
  }else{
    pattern = new RegExp(`^(\\d{0,${maxLength}})(\\.\\d{0,${maxDecimalLength}})?$`);
  }
  if (pattern.test(input_value)) {
    e.target.value = input_value;
    props.onChangeInputAction(fieldObj, e);
  } else {
    e.target.value = isSet(props.item.selectedValue, '');
    props.onChangeInputAction(fieldObj, e);
  }
});

  const attr = formFieldsAttributes(
    {...item,className:className
  },validationForms);

  return (
    <FormBlocks {...props}  attr={attr}>
        <input 
          value={attr.value}
          type={type}
          onBlur={(e)=>props.onBlurHandlerAction(fieldObj,e)}
          onChange={e => handleCheck(e)}
          {...attr.fieldAttributes}
        />
    </FormBlocks>
  );
}


Percentage.defaultProps = {
  generator: false,
  readOnly: false,
  className: "form-control",
}

const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item.selectedValue===nextProps.item.selectedValue && prevProps.validationForms===nextProps.validationForms && prevProps.item.access_mode===nextProps.item.access_mode && prevProps.item.required===nextProps.item.required){
    return true;
  }
}
export default memo(Percentage,isDiffProps);
